module.exports = __webpack_public_path__ + "3ee9efa7a9a18c50c72fa89011fdf128.svg";